<template>
    <div class="allPage">
        <Header class="header"/>
        <div class="Box scrollbar" >
            <router-view class="content"/>
        </div>
    </div>
</template>

<script>
    import Header from "../components/header/Header";

    export default {
        name: "noFooterHome",
        components: {
            Header
        },
    }
</script>

<style scoped lang="less">
    .allPage {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
        .Box {
            flex: 1;
            overflow: auto;
            display: flex;
            flex-direction: column;
        }

    }
</style>